/* eslint-disable no-unused-vars */
import { Alert, Button } from "antd";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import { FaEye, FaPrint } from "react-icons/fa";
import Preview from "../../../../components/Preview";
import { useHttp } from "../../../../hooks/http";
import { REPORT_API, URL_API, axios, moment } from "../../../../utils";
import { printform } from "../../../../utils/printforms";
import { resCatch } from "../../../util/helper";
import Table from "../components/Table";
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const limit = 10;
const Complete = ({ criteria }) => {
  const [dataSource, setDataSource] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [previewData, setPreviewData] = useState({});
  const [page, setPage] = useState(1);
  const [loadingPreview, setLoadingPreview] = useState(false);

  const [loading, data, error] = useHttp(
    {
      url: `${URL_API}/pos/operation/reserve`,
      params: {
        status: "complete",
        limit,
        offset: limit * (page - 1),
        ...criteria,
        date_from: criteria.date_from
        ? moment(criteria.date_from).format("YYYY-MM-DD")
        : null,
        date_to: criteria.date_to
        ? moment(criteria.date_to).format("YYYY-MM-DD")
        : null,
      },
    },
    [criteria, page]
  );

  useEffect(() => {
    setPage(1);
  }, [criteria]);

  useEffect(() => {
    return () => source.cancel("Operation canceled by the user.");
  }, []);

  useEffect(() => {
    if (data?.data.record) {
      setDataSource(data?.data.record);
    }
  }, [data]);

  const loadData = (id = 0) => {
    setLoadingPreview(true);
    let source = CancelToken.source();
    axios({
      url: `${URL_API}/pos/operation/reserve/${id}`,
      cancelToken: source.token,
    })
      .then((res) => {
        setPreviewData(res.data.data);
      })
      .catch((err) => {
        resCatch(err);
      })
      .finally(() => setLoadingPreview(false));
  };

  const handlePrint = (record) => {
    const bill_list = record.bill_list || [];
    for (let i = 0; i < bill_list.length; i++) {
      const bill = bill_list[i];

      const url = `${REPORT_API}/receipt?document_no=${bill.document_no}&group_type=2`;
      window.open(url, "_blank");
    }
  };

  const columns = [
    {
      title: "เลขที่ชุดจอง",
      dataIndex: "document_no",
      render: (text) => <p className="m-0 text-left">{text}</p>,
    },
    {
      title: "วันที่",
      dataIndex: "document_date",
      render: (text) => (
        <p className="m-0 text-left">
          {moment(text).format("DD/MM/YYYY HH:mm")}
        </p>
      ),
    },
    {
      title: "รหัสนักธุรกิจ",
      dataIndex: "buyer_code",
      render: (text) => <p className="m-0 text-left">{text}</p>,
    },
    {
      title: "ผู้ดำเนินการ",
      dataIndex: "buyer_name",
      render: (text) => <p className="m-0">{text}</p>,
    },
    {
      title: "ผู้ทำรายการจอง",
      dataIndex: "cashier_name",
      render: (text) => <p className="m-0">{text}</p>,
    },
    {
      title: "ผู้ยืนยัน",
      dataIndex: "complete_by",
      render: (text) => <p className="m-0">{text}</p>,
    },
    {
      title: "วันยืนยัน",
      dataIndex: "complete_date",
      render: (text) => (
        <p className="m-0">{moment(text).format("DD/MM/YYYY HH:mm")}</p>
      ),
    },
    {
      title: "ยอดรวม",
      dataIndex: "total_price",
      render: (text) => (
        <p className="m-0 text-right">{numeral(text).format("0,0.00")}</p>
      ),
    },
    {
      title: "",
      key: "action",
      render: (text, record) => (
        <p className="m-0 d-flex align-items-center justify-content-end">
          <Button
            size="small"
            className="bg-pv text-white border-pv rounded-circle d-flex p-4 mr-2"
            onClick={() => {
              loadData(record.id);
              setShowPreview(true);
            }}
          >
            <FaEye />
          </Button>
          <Button
            size="small"
            className="bg-rp text-white border-rp rounded-circle d-flex p-4"
            onClick={() => {
              // handlePrint(record)
              // receipt(record?.ref_document_id);
              printform("preview", record);
            }}
          >
            <FaPrint />
          </Button>
        </p>
      ),
    },
  ];

  if (error) return <Alert type="error" message={error} />;

  return (
    <>
      <Table
        page={page}
        setPage={setPage}
        columns={columns}
        total={data?.data?.total}
        loading={loading}
        dataSource={dataSource}
      />

      <Preview
        visible={showPreview}
        data={previewData}
        onCancel={() => setShowPreview(false)}
        loading={loadingPreview}
      />
    </>
  );
};

export default Complete;
